import { InboxDemoTheme } from '@inbox-demo-nx/theme';
import { ScenarioData, SendApiRequest } from '@inbox-demo-nx/types';
import { AnimatingCircleWrapper } from '@inbox-demo-nx/ui-animating-circle';
import { View } from 'dripsy';
import { ReactNode } from 'react';

import { APIContextProvider } from './api';
import { AuthContext, AuthContextValue } from './auth';
import { CallContextProvider } from './call';
import { IntlContextProvider } from './intl';
import { ScenarioContextProvider } from './scenario';
import { SendBirdContext, SendBirdContextValue } from './sendbird';
import { ThemeContextProvider } from './theme';

export * from './api';
export * from './auth';
export * from './call';
export * from './intl';
export * from './scenario';
export * from './sendbird';
export * from './theme';

export const ContextsProvider = ({
  children,
  authContextValue,
  scenario,
  sendbirdContextValue,
  sendApiRequest,
  isDarkTheme,
  theme,
}: {
  isDarkTheme: boolean;
  theme: InboxDemoTheme;
  children: ReactNode;
  authContextValue: AuthContextValue;
  scenario: ScenarioData;
  sendbirdContextValue: SendBirdContextValue;
  sendApiRequest: SendApiRequest;
}) => {
  return (
    <ThemeContextProvider isDarkTheme={isDarkTheme} theme={theme}>
      <APIContextProvider sendApiRequest={sendApiRequest}>
        <AuthContext.Provider value={authContextValue}>
          <ScenarioContextProvider scenario={scenario}>
            <SendBirdContext.Provider value={sendbirdContextValue}>
              <IntlContextProvider>
                <CallContextProvider>
                  <AnimatingCircleWrapper>
                    <View
                      sx={{
                        userSelect: 'none',
                        flex: 1,
                      }}
                    >
                      {children}
                    </View>
                  </AnimatingCircleWrapper>
                </CallContextProvider>
              </IntlContextProvider>
            </SendBirdContext.Provider>
          </ScenarioContextProvider>
        </AuthContext.Provider>
      </APIContextProvider>
    </ThemeContextProvider>
  );
};
